import React from 'react';
import { useTranslation } from 'react-i18next';

import { OmaLummeApp } from '../../omaLummeContext';

import newsStyles from '../News/styles/CurrentNews.module.scss';
import contactStyles from './styles/ContactLiftups.module.scss';

import Button from '../Common/Button';

// images
import liftupImage1 from '../../images/contact-liftup-1.jpg';
import liftupImage2 from '../../images/contact-liftup-2.jpg';
import liftupImage3 from '../../images/contact-liftup-3.jpg';

const Contacts: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const { users } = OmaLummeApp.useState();
  const { endpoint } = users.activeUser;

  return (
    <div className={`${newsStyles.newsItems} ${contactStyles.liftups}`}>
      <div className={`${newsStyles.newsItem} ${contactStyles.liftup} col-4 col-md-6 col-lg-6`}>
        <div className={newsStyles.top}>
          <img src={liftupImage1} alt="" />
        </div>
        <div className={newsStyles.bottom}>
          <h3 className="h2"> {t(`customerService:liftupOne.${endpoint}.customerserviceTitle`)} </h3>
          {endpoint === 'ret' && (
            <>
              <p>
                <strong>{t(`customerService:liftupOne.${endpoint}.subtitle1`)}</strong>
                <br />
                <a href={`tel:+358291800056`}>029 1800 056</a>
                <br />
                <strong>{t(`customerService:liftupOne.${endpoint}.subtitle2`)}</strong>
                <br />
                <a href={`tel:+358923150462`}>09 2315 0462</a>
                <br />
              </p>
              <Button className="buttonWhiteSmall" link={`${t(`customerService:liftupOne.${endpoint}.ctaUrl`)}`} newTab>
                {t(`customerService:liftupOne.${endpoint}.cta`)}
              </Button>
            </>
          )}
        </div>
      </div>

      <div className={`${newsStyles.newsItem} ${contactStyles.liftup} col-4 col-md-6 col-lg-6`}>
        <div className={newsStyles.top}>
          <img src={liftupImage2} alt="" />
        </div>
        <div className={newsStyles.bottom}>
          {endpoint === 'ret' && (
            <>
              <h3 className="h2"> {t(`customerService:liftupTwo.${endpoint}.title`)} </h3>
              <p>
                <strong>{t(`customerService:liftupTwo.${endpoint}.subtitle1`)}</strong>
                <br />
                <a href={`mailto:yritysmyynti@lumme-energia.fi`}>yritysmyynti@lumme-energia.fi</a>
                <br />
                <a href={`tel:+358102074830`}>010 207 4830</a>
              </p>
              <Button className="buttonWhiteSmall" link={`${t(`customerService:liftupTwo.${endpoint}.ctaUrl`)}`} newTab>
                {t(`customerService:liftupTwo.${endpoint}.ctaText`)}
              </Button>
            </>
          )}
        </div>
      </div>

      <div className={`${newsStyles.newsItem} ${contactStyles.liftup} col-4 col-md-6 col-lg-6`}>
        <div className={newsStyles.top}>
          <img src={liftupImage3} alt="" />
        </div>
        <div className={newsStyles.bottom}>
          <h3 className="h2"> {t(`customerService:liftupThree.${endpoint}.title`)} </h3>
          <p>{t(`customerService:liftupThree.${endpoint}.info1`)}</p>
          <Button className="buttonWhiteSmall" link={`${t(`customerService:liftupThree.${endpoint}.ctaUrl`)}`} newTab>
            {t(`customerService:liftupThree.${endpoint}.ctaText`)}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Contacts;
